module.exports = __webpack_public_path__ + "img/puptitle8.b500ce9c.png";